module.exports = __webpack_public_path__ + "static/media/kids_reading_orange.a9aa50a0.png";